var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"join-discord"},[_vm._m(0),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.joinDiscord}},[_vm._v("Join Server")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v("Join Discord")]),_c('p',[_vm._v("Join Our Discord Server for Daily Updates")])])
}]

export { render, staticRenderFns }